const clearEventSponsorAsset = function ({ commit }, eventSponsorId) {
  commit("CLEAR_EVENT_SPONSOR_ASSET", { eventSponsorId });
};

export default clearEventSponsorAsset;
